import React, { useEffect } from "react";
import "./Toast.css";

const Toast = ({ message, type = "info", duration = 4000, onClose }) => {
  useEffect(() => {
    if (!message) return;
    
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <span className="toast-icon">{getIcon(type)}</span>
        <span className="toast-message">{message}</span>
        <button 
          className="toast-close" 
          onClick={onClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
};

function getIcon(type) {
  switch (type) {
    case "error":
      return "⚠️";
    case "success":
      return "✓";
    case "warning":
      return "!";
    default:
      return "ℹ";
  }
}

export default Toast;
